<template>
  <div class="wrapper">
    <div class="main visual-2 abt-hospital">
      <Header :backRoute="'/appointments'" />
      <div class="hospital-info">
        <div class="row">
          <div class="col-lg-6">
            <!-- Hospital Details Section -->
            <div class="hospital-details">
              <div class="hospital-image">
                <img
                  :src="hospitalImage"
                  :alt="hospital?.name || 'Hospital'"
                  class="hospital-img"
                />

                <!-- <div class="rating">
                  <span>
                    ⭐ {{ roundedAverageRating(hospital) }} ({{
                      formattedTotalReviews(hospital)
                    }}
                    Reviews)
                  </span>
                </div> -->
              </div>
              <h2 style="margin: 20px 0">{{ hospital?.name }}</h2>
              <div class="hospital-description d-flex align-items-center">
                <div class="h-desc">
                  <!-- <h2>{{ hospital?.name }}</h2> -->
                  <div class="location" v-if="hospital?.address">
                    <i class="fa-solid fa-location-dot"></i>
                    {{ hospital?.address }}
                  </div>
                </div>
                <hr />
                <div class="hosp-btn d-flex align-items-center">
                  <router-link to="/hospital-global-settings" style="text-decoration: none;">
                    <button class="settings-btn">
                      <i class="fa-solid fa-gear"></i>
                    </button>
                  </router-link>
                  <router-link to="/hospital-profile">
                    <button class="add-new-button">Edit</button>
                  </router-link>
                  <div v-if="user.objectType === 'hospital' || user.objectType === 'super-admin' || user.objectType === 'admin'">
                    <router-link to="/add-doctor">
                      <button class="add-new-doctor">Add New Doctor</button>
                    </router-link>
                  </div>
                  <div v-else>
                    <router-link to="/add-doctor">
                      <button class="add-new-doctor">Add New Doctor</button>
                    </router-link>
                    <router-link to="/queue-counter">
                      <button class="add-new-doctor">Queue Counter</button>
                    </router-link>
                    <router-link to="/appointment-approval">
                      <button class="add-new-doctor">
                        Appointment Requests
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- Doctors Section -->
            <!-- <div class="carousel-heading">
              <h3 class="section-title">Doctors</h3>
            </div> -->
            <!--dropdown-->
            <!--dropdown-->
            <div class="d-flex mb-3 gap-2 srch-fltr">
              <input
                v-model="searchName"
                type="text"
                class="form-control"
                placeholder="Search doctor by name"
              />
              <select
                v-model="selectedSpeciality"
                class="form-control doc-dp-srch"
              >
                <option value="">Select Department</option>
                <option
                  v-for="speciality in specialities"
                  :key="speciality"
                  :value="speciality"
                >
                  {{ speciality }}
                </option>
              </select>
            </div>
            <!--dropdown-->
            <div class="doctors-grid">
              <div
                class="specialist-card"
                v-for="specialist in filteredSpecialists"
                :key="specialist.id"
              >
                <div class="specialist-content">
                  <!-- <p class="rating">
                    ⭐ {{ roundedAverageRating(specialist) }}
                  </p> -->
                  <div class="specialist-image">
                    <img
                      :src="specialist.image"
                      :alt="specialist.name"
                      class="doctor-img"
                    />
                  </div>
                  <div class="specialist-data">
                    <p class="specialty">
                      {{ limitedText(specialist.specialty, 18) }}
                    </p>
                    <h4>{{ specialist.name }}</h4>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <p class="doc-experience m-0">
                        {{ specialist.experienceYears }} yrs exp.
                      </p>
                      <!-- <p class="doc-fee m-0">
                        <i class="fa-solid fa-money-bill"></i>
                        {{
                          $formatHospitalCurrency(
                            specialist.consultationFee,
                            hospital?.id
                          )
                        }}
                      </p> -->
                    </div>
                    <div class="doc-btn">
                      <router-link
                        :to="`/doctor-appointments-list?id=${specialist.id}`"
                      >
                        <button class="view-btn">
                          {{ specialist.buttonText }}
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import { DoctorsService } from "@/services/doctors.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "HospitalSettings",
  data() {
    return {
      hospital: this.$store?.state?.user?.currentUser?.profile,
      user: this.$store?.state?.user?.currentUser,
      specialists: [],
      currentIndex: 0,
      selectedSpeciality: "", // <-- New
      specialities: [], // <-- New
      searchName: "",
    };
  },
  computed: {
    trackStyle() {
      const translateValue = -(this.currentIndex * 33.33);
      return {
        transform: `translateX(${translateValue}%)`,
        transition: "transform 0.5s ease-in-out",
      };
    },
    filteredSpecialists() {
      return this.specialists
        .filter((doc) => {
          const matchesSpeciality = this.selectedSpeciality
            ? doc.specialty === this.selectedSpeciality
            : true;
          const matchesName = this.searchName
            ? doc.name.toLowerCase().includes(this.searchName.toLowerCase())
            : true;
          return matchesSpeciality && matchesName;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    hospitalImage() {
      const storedHospitalId = localStorage.getItem("hospitalId");

      if (storedHospitalId === "68d68a07d3f9b7819cd05e80" || this.hospital?.id === "68d68a07d3f9b7819cd05e80") {
        return require("@/assets/img/494204040_1434613714551416_3095586470864192143_n.jpg");
      }

      return this.hospital?.photo || require("@/assets/img/hospital-img.png");
    },
  },
  methods: {
    roundedAverageRating(data) {
      return data?.averageRating?.averageRating
        ? data.averageRating.averageRating.toFixed(1) // Rounds to 1 decimal place
        : "0.0";
    },
    formattedTotalReviews(data) {
      const reviews = data?.averageRating?.totalReviews || 0;
      if (reviews >= 1_000_000) {
        return (reviews / 1_000_000).toFixed(1) + "M";
      } else if (reviews >= 1_000) {
        return (reviews / 1_000).toFixed(1) + "K";
      }
      return reviews.toString();
    },
    async fetchDoctors() {
      try {
        const response = await DoctorsService.getList();
        this.specialists = response.data.map((doctor) => ({
          id: doctor.id,
          name: doctor.firstname + " " + doctor.lastname,
          specialty: doctor.speciality || "General Physician",
          averageRating: doctor.averageRating || "4.5",
          timings: doctor.timings || "Not Available",
          buttonText: "View",
          image: doctor.photo || require("@/assets/img/doctor-james.png"),
          consultationFee: doctor.consultationFee || "N/A",
          experienceYears: doctor.experienceYears || 0,
        }));
        // Extract unique specialities
        const allSpecialities = this.specialists.map((d) => d.specialty);
        this.specialities = [...new Set(allSpecialities)];
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    next() {
      if (this.currentIndex < this.specialists.length - 3) {
        this.currentIndex++;
      }
    },
    limitedText(text, charLimit = 20) {
      if (!text) return "";
      return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
    },
  },
  created() {
    this.fetchDoctors();
  },
};
</script>

<style scoped>
p.doc-experience,
p.doc-fee {
  font-size: 14px;
}

.settings-btn {
  color: #fff;
  border: none;
  padding: 14px 14px;
  margin-right: 10px;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #007AF8;
  border-radius: 50%;
  color: #007AF8;
}

.settings-btn > a {
  text-decoration: none;
}

.settings-btn:hover {
  background: #007cf85e;
}

</style>
